import { PluginOutputs } from './types';

export interface OrderedPlugin {
  layer: number;
  pluginId: string;
}

/** Execution order from the plan's stages; plugins that ran but aren't in any stage go in a final layer. */
export const orderedPlugins = (outputs: PluginOutputs, stages: string[][]): OrderedPlugin[] => {
  const seen = new Set<string>();
  const ordered: OrderedPlugin[] = [];
  stages.forEach((stage, layer) =>
    stage.forEach((pluginId) => {
      if (pluginId in outputs && !seen.has(pluginId)) {
        seen.add(pluginId);
        ordered.push({ layer, pluginId });
      }
    })
  );
  Object.keys(outputs)
    .filter((pluginId) => !seen.has(pluginId))
    .sort()
    .forEach((pluginId) => ordered.push({ layer: stages.length, pluginId }));
  return ordered;
};
